import { isErrorCode } from "@iluvatar/global/src/utilities/errors";

import { getAuthRuntime } from "./firebase-auth.runtime";
import { redirectToLogin } from "./login-recovery";
import { saveTrustedComputer } from "./trusted-computer";

export async function waitForAuthReady(): Promise<void> {
  const { auth, authPersistenceReady } = await getAuthRuntime();
  await authPersistenceReady;
  await auth.authStateReady();
}

export async function setTrustedComputer(trusted: boolean): Promise<void> {
  saveTrustedComputer(trusted);
}

export function isSessionAuthError(error: unknown): boolean {
  return [
    "auth/user-token-expired",
    "auth/invalid-user-token",
    "auth/user-disabled",
    "auth/user-not-found",
  ].some((code) => isErrorCode(error, code));
}

/** Firebase reuses valid tokens and refreshes expired or soon-expiring ones. */
export async function getFreshAuthToken(): Promise<string | undefined> {
  await waitForAuthReady();
  const { auth } = await getAuthRuntime();
  const user = auth.currentUser;
  if (!user) {
    return undefined;
  }
  try {
    const token = await user.getIdToken();
    if (auth.currentUser !== user) {
      throw new Error("Authentication changed before the request was sent");
    }
    return token;
  } catch (error) {
    if (
      isSessionAuthError(error) &&
      (auth.currentUser === user || !auth.currentUser)
    ) {
      if (auth.currentUser === user) {
        await auth.signOut();
      }
      redirectToLogin();
    }
    throw error;
  }
}
